<template>
    <div>
        <div class="filter-bar d-flex justify-content-start align-items-center">
            <div class="form-group my-2">
                <label for="category" class="text-uppercase text-primary font-weight-bold"
                    >Staff time management</label
                >
                <select
                    class="form-control form-control-sm "
                    name="category"
                    id="category"
                    v-model.number="category"
                >
                    <option value="0">Staff Availability</option>
                    <option value="1">Expected Billable</option>
                    <option value="2">Staff Days Off</option>
                </select>
            </div>
            <div class="form-group my-2 ml-2">
                <div v-if="[0].includes(category)">
                    <label for="day" class="text-uppercase text-primary font-weight-bold"
                        >&nbsp;</label
                    >
                    <select class="form-control form-control-sm " name="day" id="day" v-model="d">
                        <option value="1">Monday</option>
                        <option value="2">Tuesday</option>
                        <option value="3">Wednesday</option>
                        <option value="4">Thursday</option>
                        <option value="5">Friday</option>
                        <option value="6">Saturday</option>
                    </select>
                </div>
                <div v-if="[1, 2].includes(category)">
                    <label for="month" class="text-uppercase text-primary font-weight-bold"
                        >&nbsp;</label
                    >
                    <select class="form-control form-control-sm " name="day" id="month" v-model="m">
                        <option value="0">January</option>
                        <option value="1">February</option>
                        <option value="2">March</option>
                        <option value="3">April</option>
                        <option value="4">May</option>
                        <option value="5">June</option>
                        <option value="6">July</option>
                        <option value="7">August</option>
                        <option value="8">September</option>
                        <option value="9">October</option>
                        <option value="10">November</option>
                        <option value="11">December</option>
                    </select>
                    <!--<span class="mr-2">
                        <i class="fa fa-fw fa-calendar-o"></i>
                    </span>
                    <v-date-picker popover-align="right" mode="range" v-model="interval"></v-date-picker>-->
                </div>
            </div>
            <div class="my-2 ml-auto">
                <label class="text-uppercase text-primary font-weight-bold">&nbsp;</label>
                <p class="text-primary text-uppercase font-weight-bold cursor-pointer">
                    <i class="fa fa-fw fa-filter mr-2"></i>Filter
                </p>
            </div>
        </div>

        <div class="pt-2 pb-5 px-2 bg-white">
            <div class="py-2">
                <input
                    type="text"
                    v-model="therapistFilter"
                    class="form-controlform-control-sm"
                    placeholder="Therapist name"
                />
            </div>
            <div v-if="category === 0">
                <div class="row">
                    <div class="col-2" style="font-size:1.25rem;">
                        {{
                            moment()
                                .day(d)
                                .format("dddd")
                        }}s
                    </div>
                    <div class="col-7 d-flex justify-content-between" style="font-size:1.5rem;">
                        <span>8</span>
                        <span>10</span>
                        <span>12</span>
                        <span>2</span>
                        <span>4</span>
                        <span>6</span>
                        <span>8</span>
                    </div>
                    <div class="col-3 d-flex">
                        <div class="row">
                            <div class="col-6">
                                <p class="text-right" style="border-bottom: solid 4px #b2dfe3">
                                    Scheduled Hours
                                </p>
                            </div>
                            <div class="col-6">
                                <p class="text-right" style="border-bottom: solid 4px #F9DE85">
                                    Max Hours Possible
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="user in filteredUsers">
                    <div class="col-2">
                        <div class="row">
                            <div class="col-5 pr-0">
                                <img
                                    class="img-fluid rounded-circle profile-image mt-2"
                                    :src="
                                        user && user.hasOwnProperty('picture')
                                            ? user.picture.thumbnail
                                            : '../../images/default_user.jpeg'
                                    "
                                />
                            </div>
                            <div class="col-7">
                                <p class="text-capitalize mb-0">
                                    {{ user.name.first }} {{ user.name.last }},
                                </p>
                                <small class="font-weight-bold">RBT</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-7 d-flex align-items-center">
                        <hr
                            :style="`width:${8.33 * 3}%;background:${'#b2dfe3'}`"
                            style="border:none; height: 2rem;"
                            class="m-0"
                        />
                        <hr
                            :style="`width:${8.33 * 3}%;background:${'#F9DE85'}`"
                            style="border:none; height: 2rem;"
                            class="m-0"
                        />
                        <hr
                            :style="`width:${8.33 * 4}%;background:${'#b2dfe3'}`"
                            style="border:none; height: 2rem;"
                            class="m-0"
                        />
                        <hr
                            :style="`width:${8.33 * 2}%;background:${'#F9DE85'}`"
                            style="border:none; height: 2rem;"
                            class="m-0"
                        />
                    </div>
                    <div class="col-3">
                        <div class="row">
                            <div class="col-6">
                                <p class="text-right mb-0">
                                    67 <span class="font-weight-light">h</span>
                                </p>
                            </div>
                            <div class="col-6">
                                <p class="text-right mb-0">
                                    149 <span class="font-weight-light">h</span>
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 text-right">
                                <small class="text-muted"
                                    ><i class="fa fa-angle-down"></i>82 h</small
                                >
                            </div>
                            <div class="col-6"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="category === 1">
                <div class="row">
                    <div class="col-2" style="font-size:1.25rem;">
                        {{
                            moment()
                                .month(d)
                                .format("MMMM")
                        }}
                    </div>
                    <div class="col-6 d-flex justify-content-between" style="font-size:1.5rem;">
                        &nbsp;
                    </div>
                    <div class="col-4 d-flex">
                        <div class="row">
                            <div class="col-4">
                                <p class="text-right" style="border-bottom: solid 4px #6cc7d6">
                                    Hours Worked
                                </p>
                            </div>
                            <div class="col-4">
                                <p class="text-right" style="border-bottom: solid 4px #b2dfe3">
                                    Scheduled Billable
                                </p>
                            </div>
                            <div class="col-4">
                                <p class="text-right" style="border-bottom: solid 4px #F9DE85">
                                    Expected Billable
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="user in filteredUsers">
                    <div class="col-2">
                        <div class="row">
                            <div class="col-5 pr-0">
                                <img
                                    class="img-fluid rounded-circle profile-image mt-2"
                                    :src="
                                        user && user.hasOwnProperty('picture')
                                            ? user.picture.thumbnail
                                            : '../../images/default_user.jpeg'
                                    "
                                />
                            </div>
                            <div class="col-7">
                                <p class="text-capitalize mb-0">
                                    {{ user.name.first }} {{ user.name.last }},
                                </p>
                                <small class="font-weight-bold">RBT</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 d-flex align-items-center">
                        <hr
                            :style="`width:${8.33 * 6}%;background:${'#6cc7d6'}`"
                            style="border:none; height: 2rem;"
                            class="m-0"
                        />
                        <hr
                            :style="`width:${8.33 * 4}%;background:${'#b2dfe3'}`"
                            style="border:none; height: 2rem;"
                            class="m-0"
                        />
                        <hr
                            :style="`width:${8.33 * 2}%;background:${'#F9DE85'}`"
                            style="border:none; height: 2rem;"
                            class="m-0"
                        />
                    </div>
                    <div class="col-4">
                        <div class="row">
                            <div class="col-4">
                                <p class="text-right mb-0">
                                    40 <span class="font-weight-light">h</span>
                                </p>
                            </div>
                            <div class="col-4">
                                <p class="text-right mb-0">
                                    84 <span class="font-weight-light">h</span>
                                </p>
                            </div>
                            <div class="col-4">
                                <p class="text-right mb-0">
                                    88 <span class="font-weight-light">h</span>
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 text-right">
                                <small class="text-muted">45%</small>
                            </div>
                            <div class="col-4 text-right">
                                <small class="text-muted"
                                    ><i class="fa fa-angle-down"></i>4 h</small
                                >
                            </div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="category === 2">
                <div class="pt-2">
                    <div class="col-12">
                        <schedule-days-off-chart :interval="interval"></schedule-days-off-chart>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2" style="font-size:1.25rem;">
                        {{
                            moment()
                                .month(d)
                                .format("MMMM")
                        }}
                    </div>
                    <div class="col-5 d-flex justify-content-between" style="font-size:1.5rem;">
                        &nbsp;
                    </div>
                    <div class="col-5">
                        <div class="row">
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-6">
                                        <p
                                            class="text-right"
                                            style="border-bottom: solid 4px #6cc7d6"
                                        >
                                            Hours Worked
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <p
                                            class="text-right"
                                            style="border-bottom: solid 4px #b2dfe3"
                                        >
                                            Scheduled Billable
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6"></div>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="user in filteredUsers">
                    <div class="col-2">
                        <div class="row">
                            <div class="col-5 pr-0">
                                <img
                                    class="img-fluid rounded-circle profile-image mt-2"
                                    :src="
                                        user && user.hasOwnProperty('picture')
                                            ? user.picture.thumbnail
                                            : '../../images/default_user.jpeg'
                                    "
                                />
                            </div>
                            <div class="col-7">
                                <p class="text-capitalize mb-0">
                                    {{ user.name.first }} {{ user.name.last }},
                                </p>
                                <small class="font-weight-bold">RBT</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-5 ">
                        <div class="d-flex align-items-center">
                            <hr
                                :style="`width:${8.33 * 4}%;background:${'#b2dfe3'}`"
                                style="border:none; height: 2rem;"
                                class="m-0"
                            />
                            <hr
                                :style="`width:${8.33 * 8}%;background:${'#F9DE85'}`"
                                style="border:none; height: 2rem;"
                                class="m-0"
                            />
                        </div>
                        <small class="text-muted"
                            ><b>Request 8 hr PTO</b> - Friday April 27 - Friend's Wedding</small
                        >
                    </div>
                    <div class="col-5">
                        <div class="row">
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-6">
                                        <p class="text-right mb-0">
                                            67 <span class="font-weight-light">h</span>
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <p class="text-right mb-0">
                                            149 <span class="font-weight-light">h</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 text-right">
                                        <small class="text-muted"
                                            ><i class="fa fa-angle-down"></i>82 h</small
                                        >
                                    </div>
                                    <div class="col-6"></div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="row">
                                    <div class="col-6">
                                        <p
                                            class="btn btn-sm btn-primary font-weight-bold text-white"
                                        >
                                            Approve
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <p class="font-weight-bold text-primary cursor-pointer">
                                            > Deny
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ScheduleDaysOffChart from "./ScheduleDaysOffChart";
export default {
    name: "ScheduleManagement",
    components: { ScheduleDaysOffChart },
    data() {
        return {
            d: 1,
            m: 1,
            therapistFilter: "",
            category: 0,
            apiUrl: `https://randomuser.me/api/?results=3&gender=female&nat=us`,
            users: null,
            user: null,
            interval: {
                start: new Date(),
                end: new Date(),
            },
        };
    },
    created() {
        this.interval.end.setDate(this.interval.start.getDate() + 7);
        this.fetchTeamMembers();
    },
    computed: {
        filteredUsers() {
            if (this.users) {
                return this.users.filter(
                    u =>
                        u.name.first.toLowerCase().includes(this.therapistFilter.toLowerCase()) ||
                        u.name.last.toLowerCase().includes(this.therapistFilter.toLowerCase())
                );
            } else {
                return [];
            }
        },
    },
    methods: {
        fetchTeamMembers() {
            axios.get(this.apiUrl).then(r => {
                this.users = r.data.results;
            });
        },
        detailsUser(user) {
            this.user = user;
        },
    },
};
</script>

<style scoped lang="scss">
.filter-bar {
    background-color: #f7f7f7;
    border-bottom: solid 1px #8f8f8f;
}
</style>
